import { Tooltip } from '@chakra-ui/react'
import { IEntregaDeTrabalhoUpload } from './models'

export const downloadLink = (upload: IEntregaDeTrabalhoUpload): string => {
  return `${process.env.REACT_APP_API_URL}api/entrega-de-trabalho/download/${upload.id}/${upload.original_name}`
}

export const previewLink = (upload: IEntregaDeTrabalhoUpload): string => {
  return `${process.env.REACT_APP_API_URL}api/entrega-de-trabalho/view/${upload.id}/${upload.original_name}`
}

export const ucFirst = (str: string, allWords = false): string => {
  if (!str) return ''

  if (allWords) {
    return str.toLocaleLowerCase().replace(/(\b\w)/gi, (char) => char.toLocaleUpperCase())
  }

  return str.charAt(0).toLocaleUpperCase() + str.slice(1).toLocaleLowerCase()
}

export const courseFormat = {
  presencial: 'Presencial',
  online: 'Online (vídeo aulas)',
  'online-ao-vivo': 'EAD Ao Vivo'
}

export const secondsToTime = (seconds: number): string => {
  let secondsLeft = seconds
  const months = Math.floor(seconds / 2592000)
  secondsLeft = secondsLeft - months * 2592000
  const days = Math.floor(secondsLeft / 86400)
  secondsLeft = secondsLeft - days * 86400
  const hours = Math.floor(secondsLeft / 3600)
  secondsLeft = secondsLeft - hours * 3600
  const minutes = Math.floor(secondsLeft / 60)
  secondsLeft = secondsLeft - minutes * 60

  if (months > 0) {
    return `${months} meses, ${days} dias, ${hours} horas, ${minutes} minutos e ${secondsLeft} segundos`
  }

  if (days > 0) {
    return `${days} dias, ${hours} horas, ${minutes} minutos e ${secondsLeft} segundos`
  }

  return `${hours} horas, ${minutes} minutos e ${secondsLeft} segundos`
}

export const showAlert = (createdAt: string, solvedAt: string, pendingStatus: boolean): JSX.Element => {
  const date = new Date(createdAt)
  const now = solvedAt ? new Date(solvedAt) : new Date()
  const diff = now.getTime() - date.getTime()
  const hoursDiff = diff / (1000 * 60 * 60)

  if (hoursDiff > 72) {
    if (pendingStatus) {
      return (
        <Tooltip label="Pendente há mais de 72 horas" aria-label="Pendente há mais de 72 horas">
          <div
            className="ms-1"
            style={{ width: '1rem', height: '1rem', backgroundColor: 'red', borderRadius: '50%' }}
          ></div>
        </Tooltip>
      )
    }

    return (
      <Tooltip label="Corrigido após 72 horas" aria-label="Corrigido após 72 horas">
        <i className="lni lni-cross-circle ms-1" style={{ color: 'green', fontSize: '1rem' }}></i>
      </Tooltip>
    )
  }

  if (pendingStatus) {
    return (
      <Tooltip label="Correção pendente" aria-label="Correção pendente">
        <div
          className="ms-1"
          style={{ width: '1rem', height: '1rem', backgroundColor: 'orange', borderRadius: '50%' }}
        ></div>
      </Tooltip>
    )
  }

  return (
    <Tooltip label="Corrigido dentro do prazo" aria-label="Corrigido dentro do prazo">
      <i className="lni lni-checkmark-circle ms-1" style={{ color: 'green', fontSize: '1rem' }}></i>
    </Tooltip>
  )
}
